module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('WarningMessage'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "navbar"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "grid grid-noBottom"
  }, [_c('router-link', {
    staticClass: "col-2 logo",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Sprout OJ [read-only]")]), _vm._v(" "), _c('div', {
    staticClass: "col grid"
  }, [_c('router-link', {
    staticClass: "col-1 link",
    attrs: {
      "to": "/info/"
    }
  }, [_vm._v("Informa")]), _vm._v(" "), _c('router-link', {
    staticClass: "col-1 link",
    attrs: {
      "to": "/rank/"
    }
  }, [_vm._v("Ranking")]), _vm._v(" "), _c('router-link', {
    staticClass: "col-1 link",
    attrs: {
      "to": "/status/"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('router-link', {
    staticClass: "col-1 link",
    attrs: {
      "to": "/group/"
    }
  }, [_vm._v("Collection")]), _vm._v(" "), (_vm.identity === null) ? _c('router-link', {
    staticClass: "col-2 link",
    attrs: {
      "to": "/ingress/",
      "data-push-left": "off-6"
    }
  }, [_vm._v("Sign In | Up")]) : _vm._e(), _vm._v(" "), (_vm.identity !== null) ? [(_vm.is_admin) ? [_c('router-link', {
    staticClass: "col-1 link",
    attrs: {
      "to": "/manage/group/",
      "data-push-left": "off-5"
    }
  }, [_vm._v("Manage")]), _vm._v(" "), _c('div', {
    staticClass: "col-2 grid grid-noGutter"
  }, [_c('router-link', {
    staticClass: "col link",
    attrs: {
      "to": ("/profile/" + (_vm.identity.uid) + "/")
    }
  }, [_vm._v(_vm._s(_vm.identity.name))]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('i', {
    staticClass: "fa fa-sign-out btn",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.onLogout
    }
  })])], 1)] : [_c('div', {
    staticClass: "col-2 grid grid-noGutter",
    attrs: {
      "data-push-left": "off-6"
    }
  }, [_c('router-link', {
    staticClass: "col link",
    attrs: {
      "to": ("/profile/" + (_vm.identity.uid) + "/")
    }
  }, [_vm._v(_vm._s(_vm.identity.name))]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('i', {
    staticClass: "fa fa-sign-out btn",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.onLogout
    }
  })])], 1)]] : _vm._e()], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "view"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-633b6c82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 586
// module chunks = 0